import CustomRoleGroup from './src/main.js'

const components = []

// eslint-disable-next-line space-before-function-paren
const install = function (Vue, opts = {}) {
  if (install.installed) return
  components.forEach(component => {
    Vue.component(component.name, component)
  })

  Vue.prototype.$customRoleGroup = CustomRoleGroup
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install }
